import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ isLineConnector: boolean }>()(
  (theme: Theme, { isLineConnector = false }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.shape.borderRadius,
      width: '100%',
    },

    expiredSeed: {
      boxShadow: `0 0 0 ${theme.spacing(0.125)} ${theme.palette.error.light}`,
    },

    seed: {
      '&:nth-of-type(odd):not(:last-child)::after': {
        borderColor: `${theme.palette.bracket.link} !important`,
        borderRadius: isLineConnector ? '' : `0 ${theme.shape.borderRadius}px 0 0 !important`,
      },
      '&:nth-of-type(even)::after': {
        borderRadius: isLineConnector ? '' : `0 0 ${theme.shape.borderRadius}px 0 !important`,
        borderColor: `${theme.palette.bracket.link} !important`,
      },
      '&:before': {
        borderColor: `${theme.palette.bracket.link} !important`,
      },
    },

    bracketTitle: {
      color: theme.palette.primary.light,
      fontSize: theme.spacing(1.5),
    },

    divider: {
      flexFlow: 'inherit',
      flex: '0 0 auto',
      width: '100%',
      height: '1px',
      backgroundColor: theme.palette.bracket.link,
      opacity: 0.25,
    },

    team: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flexFlow: 'row nowrap',
      flex: '0 0 auto',
      borderTopRightRadius: theme.spacing(1.25),
      borderLeft: theme.spacing(0.375),
      padding: `0 ${theme.spacing(1.875)} 0 ${theme.spacing(1.5)}`,
      borderRadius: 0,
    },

    disqualified: {
      backgroundColor: theme.palette.grey[800],
    },

    teamTop: {
      borderTopLeftRadius: theme.spacing(1.25),
      borderTopRightRadius: theme.spacing(1.25),
      height: theme.spacing(8.125),
    },

    teamBottom: {
      height: theme.spacing(8.25),
      borderBottomLeftRadius: theme.spacing(1.25),
      borderBottomRightRadius: theme.spacing(1.25),
    },

    matchNumberContainer: {
      position: 'absolute',
      left: theme.spacing(0),
      bottom: theme.spacing(-2.5),
    },

    seedDetails: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      position: 'absolute',
      justifyContent: 'space-between',
    },

    seedHeader: {
      left: theme.spacing(0),
      top: theme.spacing(-2.5),
    },

    seedFooter: {
      left: theme.spacing(0),
      bottom: theme.spacing(-2.5),
      justifyContent: 'flex-end',
    },

    seedDetailsButtons: {
      flex: 1,
      textAlign: 'right',
    },

    spectateButton: {
      marginLeft: 'auto',
      height: theme.spacing(2.5),
      padding: theme.spacing(0),
      color: theme.palette.primary.light,
      marginRight: theme.spacing(1),
    },

    viewDetailsButton: {
      marginLeft: 'auto',
      height: theme.spacing(2.5),
      padding: theme.spacing(0),
      color: theme.palette.primary.light,

      '&.MuiButtonBase-root.MuiButton-root': {
        fontSize: theme.spacing(1.5),

        '&:hover': {
          background: 'none',
          textDecoration: 'underline',
        },
      },
    },

    timer: {
      '& .MuiTypography-root': {
        fontSize: theme.spacing(1.5),
        color: theme.palette.warning.light,
      },
    },
  })
);
